<template>
  <div class="pd20x flex1">
    <div class="contentBox h100pct ofA">
      <div class="filter" style="padding:10px 20px; display: flex; justify-content: space-between; align-items: center;">
        <div style="display: flex; gap: 10px; align-items: center;">
          <label>搜索：</label>
          <a-input-search
            v-model="filter.keyword"
            placeholder="搜索商户/负责人/手机"
            style="width: 250px"
            @search="searchData"
            class="mr10px"
          />
        </div>
        <div>
          <a-button type="primary" icon="plus" @click="showAddModal">新增合作商家</a-button>
        </div>
      </div>

      <a-table
        :columns="columns"
        :data-source="data"
        :pagination="pagination"
        :loading="loading"
        rowKey="id"
        @change="changePage"
      >
        <template slot="contact" slot-scope="text, record">
          <div>{{ record.contact_name || '-' }}</div>
          <div style="font-size: 12px; color: #999;">{{ record.contact_phone }}</div>
        </template>
        <template slot="split_type" slot-scope="text, record">
          <div v-if="text === 1">
            <a-tag color="blue">固定比例</a-tag>
            <div style="font-size: 12px; color: #666; margin-top: 4px;">平台抽成: {{ record.fixed_ratio }}%</div>
          </div>
          <div v-else-if="text === 2">
            <a-tag color="orange">保底底价</a-tag>
            <div style="font-size: 12px; color: #666; margin-top: 4px;">按商品进货价结算</div>
          </div>
        </template>
        <template slot="financial" slot-scope="text, record">
          <div style="font-size: 12px;">
            <div><strong>可提现:</strong> <span style="color: #52c41a; font-weight: bold;">￥{{ record.balance.toFixed(2) }}</span></div>
            <div><strong>冻结中:</strong> ￥{{ record.frozen_balance.toFixed(2) }}</div>
            <div><strong>已提现:</strong> ￥{{ record.withdrawn.toFixed(2) }}</div>
          </div>
        </template>
        <template slot="oem" slot-scope="text, record">
          <div style="font-size: 12px;">
            <div><strong>系统名:</strong> {{ record.system_name || '官方默认' }}</div>
            <div v-if="record.custom_domain"><strong>域名:</strong> {{ record.custom_domain }}</div>
            <div v-else-if="record.domain_prefix"><strong>前缀:</strong> {{ record.domain_prefix }}</div>
            <div v-else>-</div>
          </div>
        </template>
        <template slot="status" slot-scope="text, record">
          <a-switch :checked="text === 1" @change="toggleStatus(record)" checked-children="开" un-checked-children="关" />
        </template>
        <template slot="operation" slot-scope="text, record">
          <a href="javascript:;" @click="showEditModal(record)">编辑商家配置</a>
          <a-divider type="vertical" />
          <a href="javascript:;" @click="showAssignCoursesModal(record)">分配试卷包</a>
        </template>
      </a-table>
    </div>

    <!-- 新增 / 编辑 商家弹窗 -->
    <a-modal
      :title="isEdit ? '编辑商家机构配置' : '新增合作商家'"
      :visible="modalVisible"
      :confirm-loading="submitLoading"
      @ok="handleSubmit"
      @cancel="modalVisible = false"
      okText="提交"
      cancelText="取消"
      width="600px"
    >
      <a-form-model :model="form" ref="tenantForm" :rules="rules" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
        <h3 style="margin-left: 25px; border-left: 4px solid #1890ff; padding-left: 8px; margin-bottom: 15px;">基础信息</h3>
        <a-form-model-item label="机构名称" prop="tenant_name">
          <a-input v-model="form.tenant_name" placeholder="请输入琴行/学校名称" />
        </a-form-model-item>
        <a-form-model-item label="联系人姓名" prop="contact_name">
          <a-input v-model="form.contact_name" placeholder="请输入负责人姓名" />
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="contact_phone">
          <a-input v-model="form.contact_phone" placeholder="请输入手机号" />
        </a-form-model-item>
        <a-form-model-item label="关联用户" prop="user_ids">
          <a-select
            mode="multiple"
            v-model="form.user_ids"
            placeholder="请搜索选择绑定负责人/老师"
            :filter-option="false"
            @search="searchUsers"
            style="width: 100%"
            :loading="usersLoading"
          >
            <a-select-option v-for="user in selectableUsers" :key="user.id" :value="user.id">
              {{ user.nickname || user.username }} ({{ user.username }})
            </a-select-option>
          </a-select>
          <div style="font-size: 12px; color: #1890ff; line-height: 1.5; margin-top: 4px;">
            💡 提示：填写的联系电话若在系统已有账号，系统将自动将其绑定为机构主管理员；您也可在此额外添加名下授课老师。
          </div>
        </a-form-model-item>

        <h3 style="margin-left: 25px; border-left: 4px solid #1890ff; padding-left: 8px; margin-top: 20px; margin-bottom: 15px;">财务分账配置</h3>
        <a-form-model-item label="分账模式" prop="split_type">
          <a-radio-group v-model="form.split_type">
            <a-radio :value="1">固定比例</a-radio>
            <a-radio :value="2">保底底价</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="form.split_type === 1" label="平台抽成比例 (%)" prop="fixed_ratio">
          <a-input-number v-model="form.fixed_ratio" :min="0" :max="100" :precision="2" style="width: 100%" placeholder="请输入平台服务抽成比例，如：30.00" />
        </a-form-model-item>

        <h3 style="margin-left: 25px; border-left: 4px solid #1890ff; padding-left: 8px; margin-top: 20px; margin-bottom: 15px;">OEM 自定义配置 (选填)</h3>
        <a-form-model-item label="定制系统标题" prop="system_name">
          <a-input v-model="form.system_name" placeholder="如：小星星琴行乐理训练系统" />
        </a-form-model-item>
        <a-form-model-item label="独立绑定域名" prop="custom_domain">
          <a-input v-model="form.custom_domain" placeholder="专属一级/二级域名，如: theory.qinhanga.com" />
        </a-form-model-item>
        <a-form-model-item label="子域名前缀" prop="domain_prefix">
          <a-input v-model="form.domain_prefix" placeholder="如: qinhanga" />
        </a-form-model-item>
        <a-form-model-item label="专属LOGO (URL)" prop="logo_url">
          <a-input v-model="form.logo_url" placeholder="个性化Logo图标图片URL" />
        </a-form-model-item>
        <a-form-model-item label="专属版权信息" prop="copyright">
          <a-input v-model="form.copyright" placeholder="专属底部Copyright信息" />
        </a-form-model-item>
        <a-form-model-item label="专属客服电话" prop="contact_tel">
          <a-input v-model="form.contact_tel" placeholder="客服联系座机/手机" />
        </a-form-model-item>
        <a-form-model-item label="启用状态" prop="status">
          <a-radio-group v-model="form.status">
            <a-radio :value="1">正常</a-radio>
            <a-radio :value="0">禁用</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 分配试卷包弹窗 -->
    <a-modal
      title="商户专属试卷包代理授权 / Allocate Course Bags"
      :visible="assignCoursesVisible"
      :confirm-loading="assignSubmitLoading"
      @ok="handleAssignSubmit"
      @cancel="assignCoursesVisible = false"
      okText="确认保存"
      cancelText="取消"
      width="800px"
    >
      <div style="margin-bottom: 12px; font-weight: bold; font-size: 14px;">
        当前商户: <span style="color: #1890ff;">{{ activeTenantName }}</span>
      </div>
      <a-table
        :columns="assignColumns"
        :data-source="assignData"
        :pagination="false"
        :loading="assignLoading"
        rowKey="course_bag_id"
        size="middle"
      >
        <template slot="status" slot-scope="text, record">
          <a-checkbox :checked="record.status === 1" @change="e => handleCheckedChange(e, record)" />
        </template>
        
        <template slot="custom_price" slot-scope="text, record">
          <a-input-number
            v-model="record.custom_price"
            :min="0"
            :precision="2"
            :disabled="record.status !== 1"
            placeholder="售价"
            style="width: 100px;"
          />
        </template>

        <template slot="base_price" slot-scope="text, record">
          <a-input-number
            v-model="record.base_price"
            :min="0"
            :precision="2"
            :disabled="record.status !== 1"
            placeholder="结算底价"
            style="width: 100px;"
          />
        </template>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import * as http from '@/libs/examapi'

const columns = [
  {
    title: '商户机构名称',
    dataIndex: 'tenant_name',
    align: 'center',
    width: 140
  },
  {
    title: '负责人/电话',
    key: 'contact',
    scopedSlots: { customRender: 'contact' },
    align: 'center',
    width: 120
  },
  {
    title: '分账模式',
    dataIndex: 'split_type',
    scopedSlots: { customRender: 'split_type' },
    align: 'center',
    width: 120
  },
  {
    title: '账目钱包',
    key: 'financial',
    scopedSlots: { customRender: 'financial' },
    align: 'left',
    width: 160
  },
  {
    title: 'OEM信息',
    key: 'oem',
    scopedSlots: { customRender: 'oem' },
    align: 'left'
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    align: 'center',
    width: 80
  },
  {
    title: '入驻时间',
    dataIndex: 'create_time',
    align: 'center',
    width: 150
  },
  {
    title: '操作',
    key: 'operation',
    scopedSlots: { customRender: 'operation' },
    align: 'center',
    width: 120
  }
]

const assignColumns = [
  {
    title: '授权状态',
    key: 'status',
    scopedSlots: { customRender: 'status' },
    align: 'center',
    width: 80
  },
  {
    title: '官方试卷包名称',
    dataIndex: 'title',
    align: 'left'
  },
  {
    title: '官方指导价',
    dataIndex: 'official_price',
    customRender: val => `￥${val.toFixed(2)}`,
    align: 'center',
    width: 120
  },
  {
    title: '销售价 (元)',
    key: 'custom_price',
    scopedSlots: { customRender: 'custom_price' },
    align: 'center',
    width: 140
  },
  {
    title: '结算进货底价 (元)',
    key: 'base_price',
    scopedSlots: { customRender: 'base_price' },
    align: 'center',
    width: 140
  }
]

export default {
  name: 'TenantList',
  data () {
    return {
      columns,
      data: [],
      loading: false,
      filter: {
        keyword: ''
      },
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        showTotal: total => `共 ${total} 条`
      },
      modalVisible: false,
      submitLoading: false,
      isEdit: false,
      selectableUsers: [],
      usersLoading: false,
      searchTimer: null,
      form: {
        id: undefined,
        tenant_name: '',
        contact_name: '',
        contact_phone: '',
        domain_prefix: '',
        custom_domain: '',
        system_name: '',
        logo_url: '',
        copyright: '',
        contact_tel: '',
        split_type: 1,
        fixed_ratio: 30.00,
        status: 1,
        user_ids: []
      },
      rules: {
        tenant_name: [{ required: true, message: '请输入机构名称', trigger: 'blur' }],
        contact_phone: [{ required: true, message: '请输入联系人电话', trigger: 'blur' }],
        split_type: [{ required: true, message: '请选择分账模式', trigger: 'change' }],
        fixed_ratio: [{ required: true, message: '请输入平台服务抽成比例', trigger: 'blur' }]
      },
      assignColumns,
      assignCoursesVisible: false,
      assignLoading: false,
      assignSubmitLoading: false,
      activeTenantId: undefined,
      activeTenantName: '',
      assignData: []
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      this.loading = true
      const params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        keyword: this.filter.keyword
      }
      http.getTenants(params).then(res => {
        this.loading = false
        if (res && res.data) {
          this.data = res.data
          this.pagination.total = res.total
        } else {
          this.$message.error('拉取商家列表失败')
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('获取列表异常')
      })
    },
    searchData () {
      this.pagination.current = 1
      this.getData()
    },
    changePage (pagination) {
      this.pagination.current = pagination.current
      this.getData()
    },
    showAddModal () {
      this.isEdit = false
      this.form = {
        id: undefined,
        tenant_name: '',
        contact_name: '',
        contact_phone: '',
        domain_prefix: '',
        custom_domain: '',
        system_name: '',
        logo_url: '',
        copyright: '',
        contact_tel: '',
        split_type: 1,
        fixed_ratio: 30.00,
        status: 1,
        user_ids: []
      }
      this.selectableUsers = []
      this.modalVisible = true
      this.fetchSelectableUsers()
      this.$nextTick(() => {
        if (this.$refs.tenantForm) {
          this.$refs.tenantForm.clearValidate()
        }
      })
    },
    showEditModal (record) {
      this.isEdit = true
      // 初始化回显已绑定的用户昵称
      const selectedUsers = []
      if (record.user_ids && record.user_ids.length > 0) {
        record.user_ids.forEach((id, idx) => {
          selectedUsers.push({
            id: id,
            username: record.user_names[idx] || '',
            nickname: record.user_names[idx] || '已绑定用户'
          })
        })
      }
      this.selectableUsers = selectedUsers

      this.form = {
        id: record.id,
        tenant_name: record.tenant_name,
        contact_name: record.contact_name,
        contact_phone: record.contact_phone,
        domain_prefix: record.domain_prefix || '',
        custom_domain: record.custom_domain || '',
        system_name: record.system_name || '',
        logo_url: record.logo_url || '',
        copyright: record.copyright || '',
        contact_tel: record.contact_tel || '',
        split_type: record.split_type,
        fixed_ratio: parseFloat(record.fixed_ratio),
        status: record.status,
        user_ids: record.user_ids ? [...record.user_ids] : []
      }
      this.modalVisible = true
      this.fetchSelectableUsers()
      this.$nextTick(() => {
        if (this.$refs.tenantForm) {
          this.$refs.tenantForm.clearValidate()
        }
      })
    },
    handleSubmit () {
      this.$refs.tenantForm.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        
        const actionName = this.isEdit ? 'editTenant' : 'addTenant'
        http[actionName](this.form).then(res => {
          this.submitLoading = false
          if (res !== undefined) {
            this.$message.success(this.isEdit ? '修改成功' : '新增商家成功')
            this.modalVisible = false
            this.getData()
          }
        }).catch(err => {
          this.submitLoading = false
          console.error(err)
          this.$message.error('保存失败')
        })
      })
    },
    toggleStatus (record) {
      const nextStatus = record.status === 1 ? 0 : 1
      const updateData = {
        id: record.id,
        tenant_name: record.tenant_name,
        status: nextStatus
      }
      http.editTenant(updateData).then(res => {
        if (res !== undefined) {
          this.$message.success('商户状态更新成功')
          this.getData()
        }
      }).catch(() => {
        this.$message.error('更新失败')
      })
    },
    fetchSelectableUsers (keyword = '') {
      this.usersLoading = true
      http.getSelectableUsers({ keyword }).then(res => {
        this.usersLoading = false
        if (res && Array.isArray(res)) {
          // 合并已经选中的用户，防止在选择器的候选中消失导致 label 不回显
          const currentSelected = this.selectableUsers.filter(u => this.form.user_ids.includes(u.id))
          const fetched = res
          const merged = [...currentSelected]
          fetched.forEach(item => {
            if (!merged.find(u => u.id === item.id)) {
              merged.push(item)
            }
          })
          this.selectableUsers = merged
        }
      }).catch(() => {
        this.usersLoading = false
      })
    },
    searchUsers (val) {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer)
      }
      this.searchTimer = setTimeout(() => {
        this.fetchSelectableUsers(val)
      }, 350)
    },
    showAssignCoursesModal (record) {
      this.activeTenantId = record.id
      this.activeTenantName = record.tenant_name
      this.assignData = []
      this.assignCoursesVisible = true
      this.assignLoading = true
      
      http.getTenantCourses({ tenant_id: record.id }).then(res => {
        this.assignLoading = false
        if (res !== undefined) {
          this.assignData = res || []
        } else {
          this.$message.error('拉取商户专属试卷包失败')
        }
      }).catch(err => {
        this.assignLoading = false
        console.error(err)
        this.$message.error('获取授权列表异常')
      })
    },
    handleCheckedChange (e, record) {
      record.status = e.target.checked ? 1 : 0
      if (record.status === 1) {
        if (!record.custom_price) {
          record.custom_price = record.official_price
        }
        if (!record.base_price) {
          record.base_price = parseFloat((record.official_price * 0.5).toFixed(2))
        }
      }
    },
    handleAssignSubmit () {
      let invalid = false
      this.assignData.forEach(item => {
        if (item.status === 1) {
          if (item.custom_price === undefined || item.custom_price === null || item.custom_price < 0) {
            invalid = true
          }
          if (item.base_price === undefined || item.base_price === null || item.base_price < 0) {
            invalid = true
          }
        }
      })
      
      if (invalid) {
        this.$message.warning('请为所有勾选授权的试卷包配置正确的销售价与结算底价！')
        return
      }
      
      this.assignSubmitLoading = true
      const params = {
        tenant_id: this.activeTenantId,
        courses: JSON.stringify(this.assignData)
      }
      
      http.saveTenantCourses(params).then(res => {
        this.assignSubmitLoading = false
        if (res !== undefined) {
          this.$message.success('保存试卷包代理配置成功')
          this.assignCoursesVisible = false
        } else {
          this.$message.error('保存失败')
        }
      }).catch(err => {
        this.assignSubmitLoading = false
        console.error(err)
        this.$message.error('请求异常')
      })
    }
  }
}
</script>

<style scoped>
.pd20x {
  padding: 20px;
}
.flex1 {
  flex: 1;
}
.contentBox {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.h100pct {
  height: 100%;
}
.ofA {
  overflow: auto;
}
.filter {
  border-bottom: 1px solid #f0f0f0;
}
.mr10px {
  margin-right: 10px;
}
</style>
